module.exports = __webpack_public_path__ + "img/south_sudan.389b4f5.webp";